import { createStore } from 'owa-satcheljs';
import type { AddAccountCampaignState } from './schema/addAccountCampaignState';

export const getAddAccountCampaignStore: () => AddAccountCampaignState =
    createStore<AddAccountCampaignState>('AddAccountCampaignState', {
        viewState: 'IDLE',
        titleText: '',
        bodyText: '',
        ctaText: '',
        imageVariant: '',
        trackingBaseUri: '',
        impressionBaseUri: '',
    });
